<template>
  <div class="updata" style="font-size: 16px;">
    <div style="border: 1px solid #e8e8e8;">
        <el-table
        :data="tableData"
        empty-text="暫無數據"
        stripe
        :header-cell-style="{ background: '#fafafa', color: '#000' }"
        style="width: 100%;font-size: 16px;">

        <el-table-column
            align="center"
            prop="remark"
            label="更新內容">
            <template slot-scope="scope">
                <el-tooltip  v-if="scope.row.editList.length>0" effect="light">
                    <div slot="content" style="line-height: 25px;" v-for="(item,index) in scope.row.editList" :key="index">
                        <div>{{item.remark}}</div>
                        <div :style="(index == scope.row.editList.length-1) ?   '':'border-bottom: 1px solid #e5e5e5;margin-bottom:0.5rem;padding-bottom:0.5rem;'">
                            <div style="display:flex" v-if="item.oldvalue">
                                <div>舊：</div>
                                <div>{{item.oldvalue}}</div>
                            </div>
                            <div style="display:flex">
                                <div>新：</div>
                                <div>{{item.newvalue}}</div>
                            </div>
                            
                        </div>
                    </div>
                    <span  style="color:#0c8b97;cursor: default;">個人信息</span>
                    <!-- <span  style="color:#0c8b97;cursor: default;" v-else>{{scope.row.remark}}</span> -->
                </el-tooltip>
                <span v-else>{{scope.row.remark}}</span>
            </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="createdate"
            label="提交時間">
        </el-table-column>
        <el-table-column
            align="center"
            prop="way"
            label="更新方式">
            <template slot-scope="scope">
                <div style="white-space: pre-wrap;">{{scope.row.way}}</div>
            </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="status"
            label="更新狀態">
            <template slot-scope="scope">
                <div :title="scope.row.status" class="titleSty">{{scope.row.status}}</div>
            </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="audittime"
            label="審批時間">
        </el-table-column>
        </el-table>
    </div>
    <div class="block">
        <a-pagination :defaultPageSize="5" :total="total" @change="onChange" />
    </div>
  </div>
</template>

<script>
 export default {
    props: ["items"],
    data() {
    return {
        tableData: [],
        dataAll:{},
        pageNum:'',
        total:'',
    }
    
    },
    mounted() {
        this.getUserFileStatusDetail()
    },
    methods: {
        onChange(val){
            console.log(val);
            this.pageNum = val
            console.log("chakan",this.pageNum);
            this.getUserFileStatusDetail(val);
            
        },
        getUserFileStatusDetail(ev=1) {
            this.$ajax({
                method: "post",
                url: this.$api.getUserFileStatusDetail,
                data: {
                    username:this.items.username,
                    tabname:'history_result',
                    pageNum:ev,
                    perPage:'5'
                },
            }).then((res) => {
                if (res.data.qmiscode == 1000) {
                    this.tableData = res.data.history_result;
                    this.tableData.forEach(val => {
                        if (val.remark.includes('W-8BEN') && val.remark.includes('OTC') && val.remark.includes('HKIDR')) {
                            console.log(val);
                            val.editList = [];
                        }
                        // console.log(val);
                    });
                    this.total = res.data.total
                } else {
                }
            });
        },


    },
}

</script>

<style lang="scss">
.titleSty{
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.updata{
    padding: 2rem 0 !important;
    margin: 0 2rem;
}
.block{
    text-align: right;
    padding-top: 20px;
}
.block .ant-pagination-item-active{
    background-color: #f3f3f3;
    border-color: #d8d8d8;
}
.block .ant-pagination-item-active a{
    color: #000;
}
.block .ant-pagination-next:hover .ant-pagination-item-link{
    color: #000;
    border-color: #d9d9d9;
}
.block .ant-pagination-item:hover{
    border-color: #d9d9d9;
}
.block .ant-pagination-item:hover a{
    color: rgba(0, 0, 0, 0.65);
}
.el-tooltip__popper.is-light{
    border-color:#e8e8e8;
}
.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow{
    border-bottom-color:#e8e8e8;
}
.el-tooltip__popper.is-light[x-placement^=top] .popper__arrow{
    border-top-color:#e8e8e8;
}
.el-tooltip__popper.is-light{
    font-size: 14px;
}

</style>